export default "__VITE_ASSET__Df8xCtbL__"